import {Component, HostListener, OnInit} from '@angular/core';
import {KeyLogService} from '../../../services/key-log.service';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';

@Component({
    selector: 'key-log-history',
    templateUrl: 'key-log-history.component.html',
    styleUrls: ['./key-log-history.component.scss']
})
export class KeyLogHistoryComponent implements OnInit {
    parcelNumber: string;
    keyTag: string;
    suiteId: number;
    showModal = false;
    activities: Array<any> = [];
    showSpinner = false;

    constructor(
        public keyLogService: KeyLogService,
        public api: ApiClientService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.keyTag = this.keyLogService.keyLoginKeyLogModal.keyTag;
        this.getKeyLogActivity();
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    getKeyLogActivity() {
        this.showSpinner = true;
        const url = `/v1/activity.json?per-page=10000&order-by=createdAt|desc&expand=user,createdBy&key_log_id=${this.keyLogService.keyLoginKeyLogModal.id}`;
        this.api.get('domainKeyLog', url).subscribe(
            (res)   => {this.activities = JSON.parse(res._body).entities; this.showSpinner = false; },
            (error) => this.api.errorHandler(error, 'Failed to get History')
        );
    }

    hideModal() {
        this.keyLogService.showHistoryModal = false;
        this.keyLogService.keyLoginKeyLogModal = null;
        this.urlService.modalClosed.emit();
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/key-log/key-log-history/key-log-history.component.ts